
export const cleanEmpty = obj => {
    if (Array.isArray(obj)) { 
      return obj
          .map(v => (v && typeof v === 'object') ? cleanEmpty(v) : v)
          .filter(v => !(v == null)); 
    } else { 
      return Object.entries(obj)
          .map(([k, v]) => [k, v && typeof v === 'object' ? cleanEmpty(v) : v])
          .reduce((a, [k, v]) => (!(v !== null && v !== "") ? a : (a[k]=v, a)), {});
    } 
  }

export const cleanEmptyAndFalse = obj => {
  if (Array.isArray(obj)) { 
    return obj
        .map(v => (v && typeof v === 'object') ? cleanEmptyAndFalse(v) : v)
        .filter(v => v !== null && v !== undefined && v !== false ); 
  } else { 
    return Object.entries(obj)
        .map(([k, v]) => [k, v && typeof v === 'object' ? cleanEmptyAndFalse(v) : v])
        .reduce((a, [k, v]) => {
            if (v !== null && v !== undefined && v !== false && v !== "") {
                a[k] = v;
            }
            return a;
        }, {});
  } 
}

export const isEmpty = obj => {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false;
      }
    }
    return true;
}


export const getTextWidth = (text, font) => {
    const canvas =
      getTextWidth.canvas ||
      (getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  }


  export const conditionsToString = (conditions, subCondition) => {
    if(!conditions) return;

    let result = "";

    conditions.forEach((condition) => {
      console.log("Condition to string: ", condition);

        if(subCondition 
            && (!condition.routingSkillConditions || condition.routingSkillConditions.length === 0)  
            && (!condition.languageSkillConditions || condition.languageSkillConditions.length === 0) ) return;

        result += ` ${condition.operation} `;

        if(!subCondition) {
            result += "( ";
        }

        if(condition.routingSkillConditions){
            condition.routingSkillConditions.forEach((routingCondition) => {
                result += conditionToString(routingCondition);

                if(routingCondition.childConditions){
                    result += conditionsToString(routingCondition.childConditions, true);
                }
            });
        }

        if(condition.languageSkillConditions){
            condition.languageSkillConditions.forEach((languageSkillCondition) => {
                result += conditionToString(languageSkillCondition);

                if(languageSkillCondition.childConditions){
                    result += conditionsToString(languageSkillCondition.childConditions, true);
                }
            });
        }

        if(!subCondition) {
            result += " ) ";
        }
    });

    return result;
}

const conditionToString = (condition) => {
    if(!condition) return;

    let skillName = condition.routingSkill ? condition.routingSkill : condition.languageSkill;
    return `${skillName} ${translationObject[condition.comparator]} ${condition.proficiency}`;
}

const translationObject = {
  EqualTo: '==',
  NotEqualTo: '!=',
  GreaterThan: '>',
  LessThan: '<',
  GreaterThanOrEqualTo: '>=',
  LessThanOrEqualTo: '<='
};

export const UTCStringToDate = (str) => {
  if (!str) return null;
  try {
      return new Date(str);
  } catch (e) {
      return null;
  }
}

